import { Grid, Typography, Box, Stack, IconButton, Button, TextField } from "@mui/material";
import { useForm } from "../../../../providers/FormProvider";
import { makeStyles } from "tss-react/mui";
import { useTranslation } from "react-i18next";
import TaskMapSection from "../../../common/map/TaskMapSection";
import LocationPicker from "../../../common/inputs/LocationPicker";
import { CancelOutlined as CancelIcon, Add as AddIcon } from "@mui/icons-material";


const useStyles = makeStyles()(
  (theme) => ({
    root: {
      width: "100%"
    },
  })
);

export default function RouteSection() {
  const { classes } = useStyles();
  const {
    route,
    routeRevision,
    routeDetails,
    setRouteDetails,
    locked,
  } = useForm();
  const { t } = useTranslation();


  return (
    <Stack className={classes.root} spacing={1}>

      <Typography variant="h6">
        {t("advancedForm:routeSection:title")}
      </Typography>

      <Box>
        <Grid container spacing={1} alignItems="space-between">


          {
            route?.locations?.map((wp, idx) => (
              <Grid item xs={12} key={idx}>
                <Grid container alignItems="center" spacing={1}>

                  <Grid item xs>
                    <LocationPicker
                      picker
                      label={t(idx === 0 ? "route:missionLocation" : idx === route.locations.length - 1 ? "route:transportTo" : "route:waypoint")}
                      value={wp}
                      onChange={wp.replaceFn}
                      disabled={locked}
                    />
                  </Grid>

                  {
                    idx !== 0 ? (
                      <Grid item>
                        <IconButton onClick={wp.removeFn} disabled={locked}>
                          <CancelIcon />
                        </IconButton>
                      </Grid>
                    ) : null
                  }
                </Grid>
              </Grid>
            ))
          }

          <Grid item xs={12}>
            {
              !!route ? (
                <Button size="medium" onClick={route?.addEmptyFn} startIcon={<AddIcon />} disabled={locked}>
                  {t(route?.locations.length === 1 ? "route:addTransportButton" : "route:addWaypointButton")}
                </Button>
              ) : null
            }
          </Grid>

          <Grid item xs={12}>
            <TaskMapSection
              routeRevision={routeRevision}
              route={route}
              fitScreenButton
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label={t("advancedForm:routeSection:details")}
              variant="filled"
              value={routeDetails}
              onChange={ev => setRouteDetails(ev.target.value)}
              fullWidth
              multiline
              size="small"
              minRows={2}
              disabled={locked}
            />
          </Grid>

        </Grid>
      </Box>

    </Stack >
  );
}


